<template>
  <div class="component-name">
    
  </div>
</template>

<script>
import { getDashboardPage } from '@/util/util.js';
export default {
  name: 'middleIndex',
  components: {
   
  },
  props: {
  
  },
  data() {
    return {
    
    }
  },
  computed: {
   
  },
  watch: {

  },
  created() {
    this.init()
   
  },
  mounted() {
    

  },
  methods: {
    init(){      
        let urlPath = {
        path: '/' + getDashboardPage(),
        query: {
          mac: this.$route.query.mac
        }
      };
      localStorage.setItem('dashboard.lastViewMachine', this.$route.query.mac)
      this.$router.replace(urlPath)
    }
   
  }
}
</script>

<style scoped>

</style>